import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/assets";

export const Nav = () => (
  <header className="sticky top-0 z-50 border-b border-[#eadfd2] bg-[var(--cream)]/85 backdrop-blur-md">
    <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
      <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link">
        <img src={ASSETS.logo} alt="Domaya logo" className="h-10 w-10 rounded-xl object-cover" />
        <span className="font-display text-2xl font-semibold tracking-tight text-[var(--olive-deep)]">
          Domaya
        </span>
      </Link>
      <nav className="hidden items-center gap-8 text-sm font-medium text-[var(--ink-soft)] sm:flex">
        <a href="/#features" className="transition-colors hover:text-[var(--olive)]" data-testid="nav-features-link">
          Features
        </a>
        <a href="/#screens" className="transition-colors hover:text-[var(--olive)]" data-testid="nav-screens-link">
          Inside the app
        </a>
      </nav>
      <a
        href="/#download"
        data-testid="nav-download-btn"
        className="rounded-full bg-[var(--olive)] px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors duration-300 hover:bg-[var(--olive-deep)]"
      >
        Get the app
      </a>
    </div>
  </header>
);
